import jQuery from 'jquery';
let $ = jQuery;

/**
    * class HSN.EmailSignUp
    *
    * Encapsulates Email Signup and form submissions
    **/
HSN.EmailSignUp = function () {
    var application;
    var container;
    var submitElement;
    var errorElement;
    var errorConfirmElement;

    /**
        * new HSN.Widget.Calendar.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.Calendar]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML input element that will resolve to an HTML element will act as the root container for the email form
        *   - submitElement (HTMLElement): An element that represents the submit button that will post to the email controller
        *   - errorElement  (HTMLElement): An element that respresents the error element where validation errors are returned to
        **/

    function init(config) {
        application = config.application;
        container = $(config.container);
        submitElement = config.submitElement;
        errorElement = $(config.errorElement);
        errorConfirmElement = $(config.errorConfirmElement);
        bindEvents();
    }

    function bindEvents() {
        HSN.SuggestEmail('.signup-email');
        container.on('cut copy paste', '.signup-email', function () {
            return false;
        });

        container.on('cut copy paste', '.signup-confirm-email', function () {
            return false;
        });

        container.on('keydown paste', '.signup-email', function() {
            container.find('.signup-confirm-email').show();
            return true;
        });

        container.on('click', '.email-signup-submit-btn', function (e) {
            cmCreateManualLinkClickTag('/footer-noncust-EmailSignUp?cm_re=Global-_-Footer-_-EmailSignUp&amp;cm_sp=Global-_-Footer-_-EmailSignUp', 'SaleAlerts');
            var emailAddress = container.find('.signup-email').val();
            var confirmedEmailAddress = container.find('.signup-confirm-email').val();
            errorElement.html('');
            errorConfirmElement.html('');
            container.find('#signup-email').attr('aria-invalid', false);
            container.find('#signup-confirm-email').attr('aria-invalid', false);

            $.ajax
            (
                '/headerfooter/emailsignup',
                {
                    context: this,
                    dataType: 'json',
                    type: 'POST',
                    data: { 'EmailAddress': emailAddress, 'ConfirmEmailAddress': confirmedEmailAddress, "SourceId": 57, '_ts': new Date().getTime() },
                    success: function (data) {
                        if (data.success) {
                            dataLayer.push({ 'signup_email': emailAddress });
                            HSN.DataLayer.helpers.hsnEvent(null, "EmailPromoSignupFooter", "Success", null, null);
                            container.find('input').attr('aria-invalid', false);
                            var modal = HSN.Instance().GetSignupMessageModal();
                            modal.SetElementToFocusOnClose($(e.target));
                            modal.Show("/headerfooter/signup-message/modal/get/" + btoa(emailAddress));
                            container.find('.signup-email').val('');
                            container.find('.signup-confirm-email').val('');
                            container.find('#email-error-conatiner').hide()
                            container.find('#confirm-email-error-conatiner').hide();
                            container.find('.signup-confirm-email').hide();
                            container.find('#hint').hide();
                        }
                        else {
                            if (data.errors != null) {
                                var errorMessage = '';
                                var errorConfirmMessage = '';
                                $(data.errors).each(function (index) {
                                    if (data.errors[index].toLowerCase().includes('confirm')) {
                                        errorConfirmMessage += data.errors[index] + ' ';
                                    } else {
                                        errorMessage += data.errors[index] + ' ';
                                    }
                                });

                                if (errorMessage.length > 0) {
                                    container.find('#hint').hide();
                                    errorElement.html(errorMessage);
                                    container.find('#email-error-conatiner').css('display', 'flex');
                                    container.find('#signup-email').attr('aria-invalid', true);
                                    container.find('#signup-email').focus();
                                } else if (errorConfirmMessage.length > 0) {
                                    container.find('#signup-confirm-email').focus();
                                }
                                if (errorConfirmMessage.length > 0) {
                                    errorConfirmElement.html(errorConfirmMessage);
                                    container.find('#confirm-email-error-conatiner').css('display', 'flex');
                                    container.find('#signup-confirm-email').attr('aria-invalid', true);
                                }
                            }
                            else
                                alert('Unfortunately there was an error, please try again.');
                        }
                    },
                    error: function () {
                        alert('Unfortunately there was an error, please try again.');
                    }
                }
            );
            return false;
        });
    }

    return {
        init: init
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/EmailSignUp.js